const BattleLoad = () => import("@/views/pve/BattleLoad.vue"); // 战斗加载页面
const BattleMain = () => import("@/views/pve/BattleMain.vue"); // 战斗主界面
const PveMain = () => import("@/views/pve/PveMain.vue"); // PVE 主界面
const BattleController = () => import("@/views/pve/BattleController.vue"); // 战斗总控制界面

export default [
  {
    path: "/pve/load", // 战斗加载
    name: "BattleLoad",
    component: BattleLoad,
  },
  {
    path: "/pve/battle", // 战斗主界面
    name: "BattleMain",
    component: BattleMain,
  },
  {
    path: "/pve", // PVE 主界面
    name: "PveMain",
    component: PveMain,
  },
  {
    path: "/pve/controller", // 战斗总控制界面
    name: "BattleController",
    component: BattleController,
  },
];
